function swapURLHashAndSearch(url) {
  const hashIndex = url.indexOf("#");
  const searchIndex = url.indexOf("?");
  if (hashIndex > -1 && searchIndex > -1) {
    if (hashIndex > searchIndex) {
      return url.slice(0, searchIndex) + url.slice(hashIndex, url.length) + url.slice(searchIndex, hashIndex);
    } else {
      return url.slice(0, hashIndex) + url.slice(searchIndex, url.length) + url.slice(hashIndex, searchIndex);
    }
  }
  return url;
}
class VueHashUrl extends URL {
  constructor(url) {
    const standardUrl = swapURLHashAndSearch(url);
    super(standardUrl);
  }
  toString() {
    const standardUrl = super.toString();
    return swapURLHashAndSearch(standardUrl);
  }
}
export { VueHashUrl };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/vueHashUrl.js